export default {
  data() {
    return {
      selectedRows: [],
      selectedRow: null,
      isRangeSelected: false,
      index: -1,
      isShiftPressed: false,
    };
  },
  methods: {
    handleClick(event, idx, id, parentIdx = null) {
      this.positionToolBox(idx, parentIdx);
      if (event.shiftKey) {
        this.handleRangeSelection(this.index, idx, parentIdx);
        this.index = null;
        this.isRangeSelected = true;
        return;
      } else if (event.ctrlKey) {
        this.selectedRows.push(id);
        this.isRangeSelected = true;
        this.index = null;
      } else {
        this.selectedRows = [id];
        this.index = idx;
        this.isRangeSelected = false;
      }
    },

    isSelected(id) {
      return this.selectedRows.includes(id);
    },

    handleRangeSelection(startIndex, endIndex, parentIndex = null) {
      if (startIndex > endIndex) {
        [startIndex, endIndex] = [endIndex, startIndex];
      }
      const rows =
        (this.getVisibleRows && this.getVisibleRows()) ||
        (this.getActiveDeliverables && this.getActiveDeliverables()) ||
        this.deliverables;
      for (let i = startIndex; i <= endIndex; i++) {
        const row = rows[i];
        const itemId = parentIndex
          ? row?.children?.[i]?.id
          : row?.id || row?.node?.id;
        if (itemId && !this.selectedRows.includes(itemId)) {
          this.selectedRows.push(itemId);
        }
      }
    },

    clearSelection() {
      this.selectedRows = [];
      this.index = -1;
      this.isRangeSelected = false;
    },
  },
};
